import { render, staticRenderFns } from "./UsersInscriptionTable.vue?vue&type=template&id=5be5c5a3"
import script from "./UsersInscriptionTable.vue?vue&type=script&lang=js"
export * from "./UsersInscriptionTable.vue?vue&type=script&lang=js"
import style0 from "./UsersInscriptionTable.vue?vue&type=style&index=0&id=5be5c5a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports